import React, { useState } from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import CloneChildren from "@components/children";
import {
  HeaderButtonsContainer,
  ButtonContainer,
  TabButton,
  ContentContainer
} from "./styles";

export interface INavigationTab {
  id: string;
  label: string;
  isActive?: boolean;
}
export interface INavigationTabs extends CommonProps {
  tabs?: INavigationTab[];
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const NavigationTabs = ({ children, ...props }: INavigationTabs) => {
  const { is_visible, tabs, actions, styles } = props;

  const [activeTab, setActiveTab] = useState(
    tabs?.find((tab) => tab.isActive)?.id || tabs?.[0]?.id || "dashcam"
  );

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
    const actionKey = `on_${tabId}_click` as keyof typeof actions;
    const actionArray = actions?.[actionKey] as any[] | undefined;
    if (actionArray && Array.isArray(actionArray) && actionArray.length > 0) {
      actionArray.forEach((action: any) => {
        if (typeof action.funCall === "function") {
          action.funCall(action.args || {});
        }
      });
    }
  };
  if (is_visible === false) return <></>;
  return (
    <HeaderButtonsContainer styles={styles}>
      <ButtonContainer>
        {tabs?.map((tab) => (
          <TabButton
            key={tab.id}
            isActive={activeTab === tab.id}
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.label}
          </TabButton>
        ))}
      </ButtonContainer>
      <ContentContainer>
        {children && <CloneChildren>{children}</CloneChildren>}
      </ContentContainer>
    </HeaderButtonsContainer>
  );
};

export default connect(mapStateToProps)(NavigationTabs);
